module.exports = __webpack_public_path__ + "media/images/admin/auth-bg-447e401478ed3a849208424b98bf21ca.jpg";